module.exports = __webpack_public_path__ + "static/img/趴蹬矿车识别.e07c47c8.png";